import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const BadgesContext = createContext(null);

const POLL_INTERVAL_MS = 30000;

/**
 * Contadores do menu: notificacoes nao lidas e leituras obrigatorias pendentes.
 *
 * O estado vive aqui, e nao no Layout, porque quem muda esses numeros sao as
 * paginas (marcar notificacao como lida, confirmar leitura). Com o estado no
 * Layout, a pagina nao tinha como avisar e o contador so corrigia no proximo
 * ciclo do timer — ou quando a pessoa recarregava.
 */
export function BadgesProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [pendingReadings, setPendingReadings] = useState(0);

  const refresh = useCallback(async () => {
    // Independentes: falha de uma nao pode zerar a outra
    try {
      const { data } = await api.get('/notifications/recent');
      setNotifications(data.data);
      setUnreadCount(data.unread_count);
    } catch { /* mantem o valor anterior */ }

    try {
      const { data } = await api.get('/training/me', {
        params: { status: 'pending', page: 1, limit: 1 },
      });
      setPendingReadings(data.counts.pending);
    } catch { /* mantem o valor anterior */ }
  }, []);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [refresh]);

  return (
    <BadgesContext.Provider value={{ notifications, unreadCount, pendingReadings, refresh }}>
      {children}
    </BadgesContext.Provider>
  );
}

export function useBadges() {
  const ctx = useContext(BadgesContext);
  if (!ctx) throw new Error('useBadges precisa estar dentro de BadgesProvider');
  return ctx;
}
